import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';

import { CountryCode } from './countries';
import { removeCountryPrefix } from './countryUtils/removeCountryPrefix';

const pnu = PhoneNumberUtil.getInstance();

export const generatePlaceholderNumber = (countryCode: CountryCode) => {
  if (!countryCode) {
    return '';
  }

  const exampleNumber = pnu.getExampleNumberForType(countryCode, 1);

  const formattedInternationalNumber = pnu.format(
    exampleNumber,
    PhoneNumberFormat.INTERNATIONAL
  );

  const placeholder = removeCountryPrefix(
    formattedInternationalNumber,
    countryCode
  );

  return placeholder.trim();
};
